import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { LegalDocument, legalPageUrl } from "../../utils/legal-links";

/**
 * `/terms` and `/privacy` on this host: send the reader to the login app,
 * which publishes both documents, rather than a 404.
 */
export const LegalRedirect: React.FC<{ document: LegalDocument }> = ({
  document,
}) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    window.location.replace(legalPageUrl(document, i18n.language));
  }, [document, i18n.language]);

  return null;
};
